import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Subscription } from 'rxjs';

import { ApiConstants } from 'src/app/constants/api-constants';
import { DataBroadcast, DataBroadcastModel, EntityIconDataModel, EntityModel, EntityTileOutputModel } from 'src/app/model';
import { DataService } from 'src/app/services';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-tile-header',
  templateUrl: './tile-header.component.html',
  styleUrls: ['./tile-header.component.css']
})
export class TileHeaderComponent implements OnInit, OnDestroy {

  @Input() content: EntityModel;

  @Input() taggable: boolean;

  @Input()
  set iconList(value: EntityIconDataModel[]) {
    this._iconList = value;
    this._setIcons();
  }

  get iconList() {
    return this._iconList;
  }

  @Output() tagChanged = new EventEmitter<EntityTileOutputModel>();
  @Output() cardSelected = new EventEmitter<any>();

  entityIconContent: EntityIconDataModel;
  token: string = ApiConstants.blobSasToken;

  // Configuration
  tenantGenericConfig: any = {};

  // Miscellaneous
  siteId: string;

  // Subscription
  private _subscription: Subscription;

  private _iconList: EntityIconDataModel[];
  private _defaultImage: any = {
    categoryName: 'default',
    imgUrl: '../../../../assets/images/no-icon-trl.svg',
    altName: 'default'
  };

  constructor(
    public service: ServicecallService,
    private _dataSer: DataService
  ) {
    this._setConfiguration();
    // Broadcast
    this._subscription = this._dataSer.events
    .subscribe({
      next: (broadcast: DataBroadcastModel) => {
        if (broadcast.name === DataBroadcast?.SITE_CHANGED || broadcast.name === DataBroadcast.API_REFRESH) {
          this._setConfiguration();
        }
      }
    });
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  /**
   * Determines whether tag option changed on
   * @param id
   * @param event
   */
  onTagOptionChanged(id: string, event: MatCheckboxChange) {
    this.tagChanged.emit({
      value: id,
      event: event?.checked
    });
  }

  /**
   * Gets state label
   * @param state
   * @returns
   */
  getStateLabel(state: string) {
    switch (state) {
      case 'init': return 'Available';
      case 'inside': return 'In lane';
      case 'outside': return 'Outside';
      case 'sortarea': return 'Sort Area';
      case 'missing': return 'Missing';
      case 'mismatch': return 'Misplaced';
      case 'delayed': return 'Delayed';
      case 'init_mismatch': return 'Untagged';
      default: return 'NA';
    }
  }

  onMatCardClick(event:Event, id: string) {
    event.stopPropagation();
    if(this.siteId) {
      this.cardSelected.emit(id);
    }
  }

  getOperationalStatusName(state: string) {
    if(state){
      return this.tenantGenericConfig?.trackerVehicleStateWidgets?.find((item: any)=> item?.state === state);
    } else {
      return null;
    }
  }

  /**
   * Sets icons
   * @param iconList
   */
  private _setIcons() {
    this.entityIconContent = this.iconList?.find((iconData) => iconData?.category === this.content?.category);
    if (!this.entityIconContent || this.tenantGenericConfig?.tenant === 'TRL') {
      this.entityIconContent = this.tenantGenericConfig?.tenant === 'TRL' 
        ? { 
          imgUrl: '../../../../assets/images/vehicle-suv-trl.svg', 
          altName: 'SUV', 
          categoryName: 'SUV'
        } 
        : this._defaultImage;
    }
  }
 
  /**
   * Sets configuration
   */
  private _setConfiguration() {
    this.siteId = this.service?.getSiteId();
    this.tenantGenericConfig = this.service.getConfiguration('tenantGenericConfig') ? this.service.getConfiguration('tenantGenericConfig') : null;
  }
}
